<template>

    <el-dialog
            :close-on-click-modal="false"
            :modal="false"
            :visible.sync="taoSongVisible"
            append-to-body
            title="请选择一起排车的同套运单"
            top="5vh"
            width="70%"
            class="tao-song-dialog"
            @close="handleClose"
        >
                <m-pane
                    ref="tablePage"
                    :config="config"
                    :totalData="totalData"
                    :pageTotal="pageTotal"
                    :loading="loading"
                    @searchChange="searchChange"
                    @pageChange="pageChange"
                    @sizeChange="sizeChange"
                    @selectChange="selectChange"
                >
                </m-pane>
            <div slot="footer">
                <el-button @click="handleClose">取 消</el-button>
                <el-button type="primary" @click="handleOk">确 认</el-button>
            </div>
        </el-dialog>
</template>
<script>
import mPane from '@/components/otpPanel';
import config from './config.js';
import { getTsOrdersApi } from '../../../api/dispatchCenter';
import { mapState } from 'vuex';

export default {
    components: { mPane },
    props: {
        taskDataList: {
            type: Array,
            default () {
                return [];
            }
        },
        taoSongVisible: {
            type: Boolean,
            default: false
        },
        dispatchNo: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            config: config,
            totalData: [],
            loading: false,
            pageTotal: 0,
            searchParams: {
                pageSize: 20,
                pageNo: 1,
                carrierVisibleFlag: 'Y',
                tsOrderNoList: [],
                dispatchNoList: ''
            },
            selectData: [],
            rowData: {},
            tipFlag: true // 提示开关
        };
    },
    computed: {
        ...mapState({
            supplier: state => state.supplier,
        }),
    },
    methods: {
        getList () {
            this.loading = true;
            this.searchParams.carrierCode = this.supplier.supplierCode,
            getTsOrdersApi(this.searchParams).then(res => {
                if (res && +res.code === 0) {
                    this.totalData = [];
                    this.pageTotal = 0;
                    let associationDispatchNoList = [];
                    let checkMsg = '';
                    if (res.data.transportPage && res.data.transportPage.list) {
                        this.totalData = res.data.transportPage.list || [];
                        this.pageTotal = res.data.transportPage.totalCount;
                        associationDispatchNoList = res.data.associationDispatchNoList || [];
                        checkMsg = res.data.checkMsg || '';
                    }
                    this.totalData.forEach(item => {
                        item.appointmentFlagName = +item.appointmentFlag === 1 ? '是' : '否';
                    });
                    if (this.tipFlag && checkMsg) {
                        this.$message.warning({
                            dangerouslyUseHTMLString: true,
                            message: `<div>
                        <span>${checkMsg}</span>
                        <a id="copyTraNo" href='#' style='color: #11bec1; margin-left: 20px;'>复制</a>
                        </div>`,
                            showClose: true,
                            type: 'warning',
                            duration: 5000
                        });
                        document.getElementById('copyTraNo').addEventListener('click', () => {
                            this.copyText(associationDispatchNoList.join(','));
                        });
                    }
                    this.tipFlag = false;
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        searchChange (data) {
            data.whCodeList = [];
            data.zoneNameList = [];
            if (data.whCode) {
                data.whCodeList = [data.whCode];
            }
            if (data.zoneName) {
                data.zoneNameList = [data.zoneName];
            }
            data.waveId ? data.waveIds = data.waveId.split(',') : data.waveIds = [];
            this.searchParams = {
                ...this.searchParams,
                ...data
            };
            this.getList();
        },
        handleClose() {
            this.$emit('update:taoSongVisible', false);
        },
        handleOk () {
            if (!this.selectData.length) return this.$message.warning('请先勾选数据');
            // 不是套送订单
            const noTsOrderNos = this.taskDataList.filter(v => !v.tsOrderNo);
            this.$emit('handleTaoSongDialogOk', this.selectData.concat(noTsOrderNos));
        },
        selectChange(data) {
            this.selectData = data;
        },
        pageChange (data) {
            // 分页器页数变化
            this.searchParams.pageNo = data;
            this.getList();
        },
        sizeChange (data) {
            // 分页器页数大小变化
            this.searchParams.pageSize = data;
            this.searchParams.pageNo = 1;
            this.getList();
        },
        copyText(copyText) {
            if (!copyText) return;
            var input = document.createElement('input');
            input.type = 'text';
            input.value = copyText.trim();
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
            this.$message.success(`‘${input.value}’复制成功`);
        },
        /**
         * 获取选中值中的套车编码集合
         * @param {Array} arr 需要过滤的数组
         * @param {string} tsOrderNo 过滤的标识，套车编码
         * @returns {Array} 去重后的非空套车编码集合
        */
        getUniqueTsOrderNos(arr, tsOrderNo) {
            return [...new Set(arr.flatMap(item => item[tsOrderNo] || []))];
        }
    },
    mounted () {
        this.searchParams.tsOrderNoList = this.getUniqueTsOrderNos(this.taskDataList, 'tsOrderNo');
        this.searchParams.dispatchNoList = this.dispatchNo ? [this.dispatchNo] : [];
        this.getList();
    }
};
</script>
<style lang="less">
.tao-song-dialog {
    .mPane3-back-up {
        .el-table {
            min-height: calc(~ '100vh - 300px') !important;
            max-height: calc(~ '100vh - 300px') !important;
        }
    }
    .el-dialog__footer {
        padding: 0px 20px;
        padding-bottom: 10px;
        text-align: right;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
    }
}
</style>
